<template>
    <div>
        <h2>{{ $t('[[[Brak dostępu]]]') }}</h2>
        <p>{{ $t('[[[By uzyskać dostęp do aplikacji musisz zaakceptować wszystkie regulaminy]]]') }}</p>
    </div>
</template>

<script>
export default {
    name: 'NoConsentAccessDeniedView'
};
</script>
